/**
 * Temporary force-sample rate for deal-package document navigations (PR0).
 *
 * TODO(perf-deals): Remove or lower after deal-package PR2+PR3 ship. Review by
 * 2026-11-09.
 */
export const DEAL_PACKAGE_ROUTE_TRACE_SAMPLE_RATE = 1.0;

/**
 * Parses an env override. Returns `null` when the value is not a finite rate in
 * `[0, 1]` (e.g. `off`, `10%`, `2`).
 */
export function parseDealPackageRouteTraceSampleRateEnv(
  value: string
): number | null {
  const trimmed = value.trim();
  const n = Number(trimmed);
  if (!Number.isFinite(n)) return null;
  if (n < 0 || n > 1) return null;
  return n;
}

/**
 * Effective sample rate for instrumented deal-package document traces.
 *
 * - Env unset → {@link DEAL_PACKAGE_ROUTE_TRACE_SAMPLE_RATE}
 * - Env set and valid → parsed value
 * - Env set and invalid → `appDefaultTracesSampleRate` (same as other routes)
 *
 * Override without a deploy via:
 *   - `SENTRY_DEAL_PACKAGE_ROUTE_TRACES_SAMPLE_RATE` (server / edge)
 *   - `NEXT_PUBLIC_SENTRY_DEAL_PACKAGE_ROUTE_TRACES_SAMPLE_RATE` (client + SSR)
 */
export function getDealPackageRouteTraceSampleRate(
  appDefaultTracesSampleRate: number
): number {
  const raw =
    process.env.SENTRY_DEAL_PACKAGE_ROUTE_TRACES_SAMPLE_RATE ||
    process.env.NEXT_PUBLIC_SENTRY_DEAL_PACKAGE_ROUTE_TRACES_SAMPLE_RATE;
  if (raw == null || raw === '') {
    return DEAL_PACKAGE_ROUTE_TRACE_SAMPLE_RATE;
  }
  const parsed = parseDealPackageRouteTraceSampleRateEnv(raw);
  if (parsed == null) {
    return appDefaultTracesSampleRate;
  }
  return parsed;
}
